import { createUseEntityList, createUseEntity } from 'api/base-hooks';
import { sectionApi } from './section';
import { SectionListResponse, SectionResponse } from './section-types';

const SECTION = 'section';

export const useSectionList = createUseEntityList<SectionListResponse>(SECTION, sectionApi.getList);
export const useSection = createUseEntity<SectionResponse>(SECTION, sectionApi.getItem);
